import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=2c9871a7&"
import script from "./WhiteBoard.vue?vue&type=script&lang=js&"
export * from "./WhiteBoard.vue?vue&type=script&lang=js&"
import style0 from "./WhiteBoard.vue?vue&type=style&index=0&id=2c9871a7&prod&lang=css&"
import style1 from "./WhiteBoard.vue?vue&type=style&index=1&id=2c9871a7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports